<template>
  <div class="Page Code">
    <div class="Code__title" v-html="trans('title')" />
    <div class="Code__subtitle is-1" v-html="trans('subtitle1')" />

    <div class="Code__img">
      <img :src="require('./img/code.png')" />
    </div>

    <router-link :to="{ name: 'map.' + lang }" class="Code__btn" v-html="trans('back')" />

    <Frame type="code" />
  </div>
</template>

<script>
import Frame from '@/components/frame/Frame'

export default {
  name: 'Code',
  components: { Frame },
  translations: {
    fr: {
      title: 'Merci d’avoir partagé!',
      subtitle1: 'Vous obtenez un rabais de 15 % à la boutique marchandise.<br>Valide une fois seulement. Non valide pour les aliments et boissons.',
      back: 'Ce code est maintenant accessible par la carte.'
    },
    en: {
      title: 'Thanks for sharing!',
      subtitle1: 'You unlocked 15% off at the merchandise store.<br>Valid one time only. Not valid for food or beverages. <Paste>',
      back: 'This code will now be accessible via the map.'
    }
  },
  created() {
    dataLayer.push({
      "useCaseStep": { "Id": "UCS545 - Game experience - Coupon page | PV", "trackType": "PV" },
      "event": "VPV",
      "page": {
        ...this.tracking.page,
        "contentName": "experience",
        "gaStep": "experience-success",
        requestURI: this.tracking.page.requestURI + "experience-success",
      },
      show: this.tracking.show
    })
  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.Code
  text-align center
  text-transform uppercase

  &__title
    margin-top 60px
    color dark-gold
    font-size 22px
    position relative
    margin-bottom 40px
    &:after
      content ' '
      position absolute
      left 50%
      transform translateX(-50%)
      height 1px
      background dark-gold
      bottom -10px
      width 85px

  &__subtitle
    margin 0 40px 20px
    line-height 22px

  &__img
    width 270px
    height 192px
    margin 30px auto
    background-image url('./img/bg_code.png')
    background-size cover
    position relative
    img
      width 200px
      height 60px
      position absolute
      top 50%
      left 50%
      transform translate(-50%, -50%)
      display block

  &__btn
    font-size 18px
    position absolute
    width 180px
    line-height 22px
    bottom 40px
    left 50%
    transform translateX(-50%)
    text-decoration none



</style>
